export { default as Main } from './Main';
export { default as Navbar } from './NavBar';
export { default as AddReport } from './AddReport';
export { default as AddComment } from './AddComment';
export { default as ExpiredReports } from './ExpiredReports';
